export enum WEB_COMMON_ASSET_KEYS {
  WEB_COMMON_ERROR_STATE_IMAGE = 'WEB_COMMON_ERROR_STATE_IMAGE',
}

export type WebCommonAssets = Record<WEB_COMMON_ASSET_KEYS, string>;
